import * as _ from 'lodash'
import * as React from 'react'

import { ErrorBoundary, Loader } from '../Common'
import * as T from './Types'

//import { JWT_ID  } from './Authenticated'

export interface Props {
  networkStateError?: string
  networkStatePending?: string
  networkStateSuccess?: string
  owner: React.Component
  sdk: any
  sdkDataMethod: any
  children: React.ReactNode,
}

export interface State {
  request: string
  response: T.JsonResponse | T.JsonErrorResponse | undefined
}

/**
 * Wrapper for any component that depends on network data.
 */
export class NetworkData extends React.PureComponent<Props, State> {
  public networkStateError: string
  public networkStatePending: string
  public networkStateSuccess: string

  constructor (props: Props) {
    super(props)

    this.networkStateError = _.get(this.props, 'networkStateError', 'error') || 'error'
    this.networkStatePending = _.get(this.props, 'networkStatePending', 'pending') || 'pending'
    this.networkStateSuccess = _.get(this.props, 'networkStateSuccess', 'success') || 'success'

    this.state = {
      request: 'pending',
      response: undefined,
    }

    _.bindAll(this, [
      'renderBody',
      'sdkCallback',
    ])
  }

  protected sdkCallback (state: string) {
    this.setState(() => {
      return {
        request: state,
      }
    })
  }

  protected renderBody (): React.ReactNode {
    const { response } = this.state

    switch (this.state.request) {
      case this.networkStateError:
        const message = _.get(response, 'message', 'Network error')
        console.warn('NETWORK ERROR:', JSON.stringify(response))

        // Handle expired token stuff here...
        const error: string = ''
        if ('Refresh token is expired!' === error) {
          // Clear out the session stuff...
          //sessionStorage.removeItem(KC_ID)
          //sessionStorage.removeItem(JWT_ID)
          //sessionStorage.removeItem(JWT_REFRESH_TOKEN)
          window.location.href = '/'
        }

        return <div>{message}, please refresh and try again...</div>

      case this.networkStateSuccess:
        return this.props.children

      case this.networkStatePending:
      default:
        return (
          <div className='flex justify-center'>
            <div className='w-16 h-16'>
              <Loader />
            </div>
          </div>
        )
    }
  }

  // Handles the fetch of aggregate object and destructures to pieces.
  public async fetchData () {
    try {
      // const response: T.DashResponse = await SDK.getDashboard()
      const response: T.JsonResponse = await this.props.sdkDataMethod.bind(
        this.props.sdk,
        this.sdkCallback)()

      this.setState({ response })

      const data = _.get(response, 'data', response)

      // If the network request was fine, update the owner's state.
      if (data !== undefined && !_.has(data, 'error')) {
        // console.info('Loaded data via NetworkData:', data)
        this.props.owner.setState.bind(this.props.owner, (prevState: T.GenericState): T.GenericState => {
          const total = _.get(response, 'total', 0)
          if (prevState.paginationTotal !== undefined) {
            return {
              data,
              paginationTotal: total,
            }
          }

          return { data }
        })()
      }
    } catch (reason) {
      console.warn(reason)
    }
  }

  public async componentDidMount () {
    try {
      await this.fetchData()
    } catch (reason) {
      console.warn(reason)
    }
  }

  public render (): React.ReactNode {
    if (window._env_?.NODE_ENV === 'test') {
      return this.props.children
    }

    return (
      <ErrorBoundary>
        {this.renderBody()}
      </ErrorBoundary>
    )
  }
}

export default NetworkData
